import MinhasRotas from "./minhasRotas";
/*List3-List4-BucketList */

function App() {
  return (
    <MinhasRotas />
  );
}

export default App;
